import { recordPath, recordRoute } from '@/shared/registry'

/** Where the Lab on Demand connection pages live. */
export const connectionsPath = '/launch/lab-on-demand-connections'
export const createConnectionPath = `${connectionsPath}/new`
export const connectionRoute = recordRoute('launch', 'lab-on-demand-connections')
export const editConnectionRoute = `${connectionRoute}/edit`

/** A connection's details page. */
export function connectionPath(id: string): string {
  return recordPath('launch', 'lab-on-demand-connections', id)
}

/** The base of the connection details page's slots (`detailsSlots`). */
export const connectionDetailsSlot = 'launch.lab-on-demand-connection-details'

/** The API's connection endpoints. */
export const connectionsApi = '/launch/v1/lab-on-demand/connections'

export function connectionApi(id: string): string {
  return `${connectionsApi}/${encodeURIComponent(id)}`
}

/** A connection's lab profile sync: read it, or post to it to sync now. */
export function connectionSyncApi(id: string): string {
  return `${connectionApi(id)}/sync`
}

/** A connection's webhooks in Lab on Demand: read them, or post to retry to set them up again. */
export function connectionWebhooksApi(id: string): string {
  return `${connectionApi(id)}/webhooks`
}

export function connectionWebhooksRetryApi(id: string): string {
  return `${connectionWebhooksApi(id)}/retry`
}

/** A connection's role mapping screen (LCH-10). */
export const roleMappingsRoute = `${connectionRoute}/role-mappings`

export function roleMappingsPath(connectionId: string): string {
  return `${connectionPath(connectionId)}/role-mappings`
}

/** The API's mapping endpoints: an organization's mappings, a connection's role mappings, and one of each. */
export const organizationMappingsApi = '/launch/v1/lab-on-demand/organization-mappings'
export const roleMappingsApi = '/launch/v1/lab-on-demand/role-mappings'

export function organizationMappingsFor(organizationId: string): string {
  return `${organizationMappingsApi}?${new URLSearchParams({ organizationId }).toString()}`
}

export function organizationMappingApi(id: string): string {
  return `${organizationMappingsApi}/${encodeURIComponent(id)}`
}

export function roleMappingsFor(connectionId: string): string {
  return `${roleMappingsApi}?${new URLSearchParams({ connectionId }).toString()}`
}

export function roleMappingApi(id: string): string {
  return `${roleMappingsApi}/${encodeURIComponent(id)}`
}

/** The permissions the pages need. */
export const readPermission = 'launch.lab-on-demand.read'
export const writePermission = 'launch.lab-on-demand.write'
